module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-quote-blue-775bc2ba7c2709e2718a71898873ea0c.svg";